import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { MyPageMenu } from 'components';

class CtMyPageMenu extends Component {
  constructor(props) {
    super(props);

    this.handleItemClick = this.handleItemClick.bind(this);
  }

  handleItemClick = (e, data) => {
    this.props.history.push(this.props.match.url + '/' + data.name);
  };

  render() {
    const { location, match, serviceNo, originalServiceNo } = this.props;
    const { handleItemClick } = this;

    let activeLink = serviceNo === originalServiceNo ? 'profile' : 'smtp';
    if (location.pathname && match.url && location.pathname !== match.url) {
      activeLink = location.pathname.replace(match.url + '/', '');
    }

    return (
      <MyPageMenu
        activeItem={activeLink}
        onClickItem={handleItemClick}
        serviceNo={serviceNo}
        originalServiceNo={originalServiceNo}
      />
    );
  }
}

CtMyPageMenu.propTypes = {};
CtMyPageMenu.defaultProps = {};

const mapStateToProps = state => {
  return {
    serviceNo: state.user.get('user').serviceNo,
    originalServiceNo: state.user.get('user').originalServiceNo
  };
};

export default withRouter(connect(mapStateToProps)(CtMyPageMenu));



// WEBPACK FOOTER //
// ./src/script/containers/mypage/CtMyPageMenu.js